<template>
  <div
    class="content-block sale-block"
    data-aos="fade-up"
    data-aos-duration="800"
  >
    <div class="block-left">
      <div class="block-number">03</div>
      <BlockHeader
        title="销售平台"
        subtitle="全渠共振，品销双赢"
        subtitleEn="SALES SECTION"
      />
      <div class="block-ornament">
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
        <div class="ornament-item"></div>
      </div>
    </div>
    <div class="block-right">
      <div class="block-content">
        <div class="sale-features">
          <div class="feature-item">
            <div class="feature-title feature-title-blue">线上</div>

            <div class="feature-content">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                以浙江老字号“太丰”为主，推进线上线下全渠道融合，产品已覆盖天猫、抖音、京东等主流电商平台。并通过抖音、淘宝、小红书等平台的精细化运营与KOL/KOC共振，太丰凭借过硬的品质，成功通过“东方甄选”、“交个朋友”等顶流直播平台的严苛选品标准，成为其长期合作的明星单品。2023成功跻身抖音黑标品牌之列，成为卤牛肉干细分领域TOP1。
              </p>
            </div>
            <div class="feature-image">
              <img
                  src="@/assets/sale/1.png"
                  alt="线上销售平台"
                  class="feature-img"
              >

            </div>
          </div>
          <div class="feature-item">
            <div class="feature-title">线下</div>

            <div class="feature-content">
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                在卤味零食市场中，核心品牌太丰，现已入驻711、罗森、全家、美宜佳、大润发、永辉超市等各大主流KA连锁商超。除太丰外，旗下还延伸出牧牛趣、卤太丰等多个子品牌系列。这些品牌主打散装称重包装形式，以灵活的销售模式覆盖更广泛消费人群，重点布局零食连锁及商超等渠道体系，并积极向下沉市场拓展延伸，进一步推动品牌规模化增长。
              </p>
            </div>
            <div class="feature-image">
              <img
                  src="@/assets/sale/2.jpg"
                  alt="线下销售渠道"
                  class="feature-img"
              >

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BlockHeader from "../common/BlockHeader.vue";

export default {
  components: { BlockHeader },
  name: "SaleBlock",
};
</script>

<style scoped>
.sale-block {
  display: flex;
  background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
  border-radius: 15px;
  margin-bottom: 40px;
  border: 1px solid rgba(154, 27, 30, 0.1);
  box-shadow: 0 8px 25px rgba(154, 27, 30, 0.08);
  overflow: hidden;
  position: relative;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.sale-block:hover {
  transform: translateY(-5px);
  border-color: rgba(154, 27, 30, 0.3);
  box-shadow: 0 15px 35px rgba(154, 27, 30, 0.12);
}

.sale-block .block-left {
  flex: 0 0 280px;
  padding: 35px 25px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, rgba(154, 27, 30, 0.05), transparent);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-right: 1px solid rgba(154, 27, 30, 0.1);
}

.sale-block .block-number {
  position: absolute;
  top: 15px;
  left: 15px;
  font-size: 3.5rem;
  font-weight: 900;
  color: rgba(154, 27, 30, 0.05);
  z-index: 0;
}

.sale-block .block-ornament {
  position: absolute;
  bottom: 25px;
  display: flex;
  gap: 6px;
}

.sale-block .ornament-item {
  width: 3px;
  height: 18px;
  background: linear-gradient(to top, #9a1b1e, transparent);
  border-radius: 1.5px;
}

.sale-block .ornament-item:nth-child(2) {
  height: 24px;
  background: linear-gradient(to top, #b22222, transparent);
}

.sale-block .ornament-item:nth-child(3) {
  height: 20px;
  background: linear-gradient(to top, #d32f2f, transparent);
}

.sale-block .block-right {
  flex: 1;
  padding: 35px 30px;
  position: relative;
  z-index: 1;
}

.sale-block .block-content {
  margin-bottom: 25px;
}

.sale-block .block-desc {
  font-size: 1rem;
  line-height: 1.7;
  color: #444;
  margin-bottom: 25px;
  text-align: justify;
}

.sale-block .sale-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  margin-top: 25px;
}

.sale-block .feature-item {
  background: white;
  border-radius: 10px;
  padding: 18px;
  border: 1px solid rgba(154, 27, 30, 0.08);
  transition: all 0.3s;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.02);
}

.sale-block .feature-item:hover {
  background: rgba(154, 27, 30, 0.03);
  border-color: rgba(154, 27, 30, 0.2);
  transform: translateY(-3px);
  box-shadow: 0 6px 15px rgba(154, 27, 30, 0.08);
}

.sale-block .feature-icon {
  width: 45px;
  height: 45px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.sale-block .feature-icon i {
  font-size: 1.3rem;
  color: white;
}

.sale-block .feature-title {
  padding: 10px 20px;
  background: linear-gradient(135deg, #9a1b1e, #b2222222);
  border-radius: 20px;
  color: #fff;
}

.sale-block .feature-title-blue {
  background: linear-gradient(135deg, #2980b9, #3498db22);
}

.sale-block .feature-content h4 {
  font-size: 1.1rem;
  color: #222;
  margin-bottom: 5px;
  font-weight: 600;
}

.sale-block .feature-content p {
  font-size: 1rem;
  color: #444;
  line-height: 1.7;
}

.sale-block .block-footer {
  display: flex;
  justify-content: flex-end;
}

.sale-block .block-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: linear-gradient(135deg, #9a1b1e, #b22222);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 50px;
  cursor: pointer;
  font-weight: 700;
  transition: all 0.3s;
  font-size: 0.95rem;
  letter-spacing: 0.5px;
  box-shadow: 0 8px 20px rgba(154, 27, 30, 0.2);
  position: relative;
  overflow: hidden;
  text-decoration: none;
}

.sale-block .block-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s;
}

.sale-block .block-btn:hover {
  transform: translateX(5px);
  box-shadow: 0 12px 30px rgba(154, 27, 30, 0.3);
  color: white;
  text-decoration: none;
  background: linear-gradient(135deg, #b22222, #d32f2f);
}

.sale-block .block-btn:hover::before {
  left: 100%;
}

.sale-block .block-btn i {
  transition: transform 0.3s;
}

.sale-block .block-btn:hover i {
  transform: translateX(5px);
}

@media (max-width: 1200px) {
  .sale-block .block-left {
    flex: 0 0 250px;
  }

  .sale-block .sale-features {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 992px) {
  .sale-block {
    flex-direction: column;
  }

  .sale-block .block-left {
    flex: 0 0 auto;
    padding: 30px 25px;
    border-right: none;
    border-bottom: 1px solid rgba(154, 27, 30, 0.1);
  }

  .sale-block .block-right {
    padding: 30px 25px;
  }
}

@media (max-width: 768px) {
  .sale-block .block-left {
    padding: 25px 20px;
  }

  .sale-block .block-right {
    padding: 25px 20px;
  }

  .sale-block .block-title {
    font-size: 1.6rem;
  }

  .sale-block .sale-features {
    grid-template-columns: 1fr;
  }

  .sale-block .block-btn {
    width: 100%;
    justify-content: center;
  }
}

.sale-block::after {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 200px;
  height: 200px;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.03) 0%,
    transparent 70%
  );
  z-index: 0;
}

.sale-block > * {
  position: relative;
  z-index: 1;
}






.sale-block .feature-content p {
  text-indent: 0;
  margin-top: 0;
}

.sale-block .feature-image {
  position: relative;
  width: 100%;
  height: 200px;
  border-radius: 8px;
  overflow: hidden;
  margin: 15px 0 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.sale-block .feature-item:hover .feature-image {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.sale-block .feature-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.sale-block .feature-item:hover .feature-img {
  transform: scale(1.03);
}

.sale-block .image-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  color: white;
  padding: 15px;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 1px;
}

@media (max-width: 992px) {
  .sale-block .feature-image {
    height: 180px;
  }
}

@media (max-width: 768px) {
  .sale-block .feature-image {
    height: 160px;
    margin: 12px 0 16px;
  }

  .sale-block .image-overlay {
    padding: 10px;
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .sale-block .feature-image {
    height: 140px;
  }
}
</style>
